<template>
    <div>
      <div class="card" style="padding: 5px 10px 5px; border-radius: 10px">
        <div class="card-header">
          <div class="row">
            <div class="col-md-10">
              <strong style="font-size:20px">Información por especialidades</strong><br />
              <span style="color: darkgrey"
                >Información de las ganancias de avanza por especialidad</span
              >
            </div>
            <!-- <div class="col-md-2">
              <button
                class="btn pull-right"
                style="border-radius: 8px"
                @click="abrirModal()"
              >
                <i class="fa fa-arrow-right"></i>
              </button>
            </div> -->
          </div>
        </div>
        <hr>
        <div class="card-content">
          <div class="row">
            <div
              class="col-md-6"
              v-for="especialidad in informacionEspecialidad"
              :key="especialidad.nombre"
            >
                <nomicard :title="especialidad.nombre" :clase="especialidad.clase" imgRoute="static/img/nomina/ganador.png" :value="especialidad.realizadas"></nomicard>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
    <script>
  import nomicard from "src/components/aDashboard/nomina/cardnominaespecialidad.vue";
  import axiosInstance from "src/global-services/axiosInstance";
  import formatearPesosColombianos from "../../../global-services/formatear-pesos";

  export default {
    data() {
      return {
        informacionEspecialidad: [],
      };
    },
    components: {
        nomicard,
    },
    methods: {
      getInformationEspecialidades: async function (fechaInicial, fechaFinal) {
        try {
          const BASE_URL = `api/informacion-dashboard-especialidad/${fechaInicial}/${fechaFinal}`;
          const response = await axiosInstance.get(BASE_URL);
          if (response.data.status == true) {
            const data = response.data.data;
            let dataFormated = data.map((element) => {
              var clase = '';
              var nombre = ''
              if(element.especialidad == 2){
                clase = 'fisioterapia';
                nombre = 'fisioterapia';
              }else if(element.especialidad == 3){
                clase = 'fonoaudiologia';
                nombre = 'fonoaudiologia';
              }else if(element.especialidad == 4){
                clase = 'terapia_ocupacional';
                nombre = 'terapia ocupacional';
              }else if(element.especialidad == 5){
                clase = 'educacion_especial'
                nombre = 'educacion especial';
              }else{
                clase = 'psicologia';
                nombre = 'psicologia';
              }

              return {
                nombre: nombre.toLocaleUpperCase(),
                realizadas: formatearPesosColombianos(element.Realizadas),
                clase: clase,
              };
            });
            
            this.informacionEspecialidad = dataFormated;
          }
        } catch (error) {
        } finally {
        }
      },
    },
    components: {
      nomicard,
    },
  };
  </script>


// WEBPACK FOOTER //
// src/components/aDashboard/nomina/informacionEspecialidad.vue